import Dashboard from './Dashboard.yaml?component';
import Notifications from './Notifications.yaml?component';

export { Dashboard, Notifications };
